import { render, staticRenderFns } from "./public.view.vue?vue&type=template&id=51542ed7&"
import script from "./public.view.ts?vue&type=script&lang=ts&"
export * from "./public.view.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports